import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const NextPage = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 17 20">
      <path d="M3.449,0.358c-1.04,-0.67 -2.425,-0.373 -3.094,0.665c-0.194,0.302 -0.312,0.645 -0.345,1l-0.01,0.214l0.033,15.45c0.003,1.237 1.007,2.24 2.243,2.24c0.33,0 0.656,-0.072 0.953,-0.212l0.217,-0.117l12.257,-7.52c1.053,-0.645 1.38,-2.023 0.732,-3.078c-0.141,-0.228 -0.321,-0.43 -0.532,-0.594l-0.164,-0.116l-12.29,-7.932Zm-1.823,1.452c0.203,-0.29 0.58,-0.394 0.9,-0.26l0.116,0.062l12.29,7.93c0.094,0.061 0.174,0.142 0.232,0.238c0.192,0.312 0.127,0.71 -0.136,0.945l-0.108,0.08l-12.257,7.52c-0.117,0.072 -0.252,0.11 -0.39,0.11c-0.37,0 -0.679,-0.27 -0.738,-0.625l-0.01,-0.121l-0.033,-15.451c0,-0.108 0.023,-0.214 0.067,-0.31l0.052,-0.095l0.015,-0.023Z" />
    </svg>
  );
};

NextPage.defaultProps = {
  width: '100%',
  height: '100%',
};

export default NextPage;
